import { useCallback, useRef } from 'react';

import PersonIcon from '@mui/icons-material/PersonOutline';

import ListItem from '@zenbusiness/zui/ListItem';

import { usePartnerEntity } from '#client/hooks/usePartnerEntity';

import { MenuItem } from './components/MenuItem';
import { ProfileInfo } from './components/ProfileInfo';
import { getUserMenuConfig } from './config';
import * as Styled from './UserMenu.style';
import useAnchorElement from '../../hooks/useAnchorElement';

const anchorEventProps = {
  elementAsset: 'user-outline.svg',
  elementName: 'user_menu_button',
  elementStyle: 'icon'
};

function UserMenu() {
  const { partner } = usePartnerEntity();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const { anchorElement, onButtonClick, onMenuClose } = useAnchorElement(
    menuRef,
    buttonRef
  );
  const open = Boolean(anchorElement);

  // Prevent the menu from closing when clicking the scrollbar
  const onMenuBlur = useCallback((e) => {
    if (e.relatedTarget && menuRef.current.contains(e.relatedTarget)) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      onMenuClose();
    }
  }, [onMenuClose]);

  return (
    <>
      <Styled.Button
        aria-controls="profile-menu"
        aria-haspopup="true"
        clickstreamProps={anchorEventProps}
        label="profile menu"
        icon={<PersonIcon />}
        onClick={onButtonClick}
        ref={buttonRef}
        open={open}
        variant="contained"
      />

      <Styled.Menu
        anchorEl={anchorElement}
        id="profile-menu"
        onBlur={onMenuBlur}
        onClose={onMenuClose}
        open={open}
        ref={menuRef}
      >
        <ListItem sx={{ padding: 0 }}>
          <ProfileInfo />
        </ListItem>

        {getUserMenuConfig(partner).map(({ element, ...section }, idx) => {
          const MenuItemComponent = element ?? MenuItem;

          return (
            <MenuItemComponent
              index={idx}
              key={section.type === 'divider' ? 'divider' : section.title}
              onClick={onMenuClose}
              section={section}
            />
          );
        })}
      </Styled.Menu>
    </>
  );
}

export default UserMenu;
